<template>
    <section class="pb-0">
        <div class="row mb-4">
            <div class="col-md-4">
                <Photoswipe>
                    <img
                        :src="_.first(selectedProduct.images)"
                        class="w-100 mb-3"
                        v-pswp="_.first(selectedProduct.images)"
                    />
                    <div class="row" v-if="selectedProduct.images.length > 1">
                        <div
                            class="col-4"
                            v-for="(image, index) in _.slice(selectedProduct.images, 1)"
                            :key="index"
                        >
                            <img :src="image" class="w-100" v-pswp="image" />
                        </div>
                    </div>
                </Photoswipe>
            </div>
            <div class="col">
                <div class="mb-3">
                    <h1 class="h2 d-inline">{{ selectedProduct.name }}</h1>
                    <span v-if="selectedProduct.draft" class="badge rounded-pill bg-secondary ms-2">{{t.product.draft}}</span>
                    <div v-if="selectedProduct.ref">Ref.: {{selectedProduct.ref}}</div>
                </div>
                <div class="h5">
                    <div v-if="variations && variations.length">
                        <div v-if="product.minPrice != product.maxPrice">
                            {{amountWithCurrency(product.minPrice)}} ~ {{amountWithCurrency(product.maxPrice)}}
                        </div>
                    </div>
                    <div v-else-if="product.discount_price">
                        <span class="h6 text-decoration-line-through me-2">{{amountWithCurrency(product.public_price)}}</span>
                        <span>{{amountWithCurrency(product.price)}}</span>
                    </div>
                    <div v-else>
                        {{amountWithCurrency(product.price)}}
                    </div>
                </div>
                <div v-if="variations && variations.length">
                    <div class="mb-3">
                        <label class="fw-bold">{{ t.product.select_options }}</label>
                        <select
                            class="form-select w-auto"
                            v-model="selectedProduct"
                            @change="changeUrl"
                        >
                            <option
                                v-for="prod in variations"
                                :key="prod.id"
                                :value="prod"
                            >
                                <span v-for="(variationAttribute, index) in product.variationAttributes" :key="index">
                                    {{ prod.products_attributes_values.find((prod_attr_val) => prod_attr_val.attribute_id == variationAttribute.id).attribute.name }}:
                                    {{ prod.products_attributes_values.find((prod_attr_val) => prod_attr_val.attribute_id == variationAttribute.id).value.name }}
                                    <span v-if="index != Object.keys(product.variationAttributes).length - 1"> / </span>
                                </span>
                            </option>
                        </select>
                    </div>
                </div>
                <div v-if="!config.modules.catalog_mode || settings.show_price">
                    <div v-if="selectedProduct" class="mb-3">
                        <div v-if="selectedProduct.discount_price">
                            <span class="h6 text-decoration-line-through me-2">
                                {{ amountWithCurrency(selectedProduct.public_price) }}
                            </span>
                            <span class="h5">
                                {{ amountWithCurrency(selectedProduct.discount_price) }}
                            </span>
                        </div>
                        <div class="h5" v-else-if="selectedProduct.price">
                            {{ amountWithCurrency(selectedProduct.price) }}
                        </div>
                    </div>
                </div>
                <div class="mb-3">{{selectedProduct.description}}</div>
                <div v-if="!config.modules.catalog_mode">
                    <div class="row" v-if="!config.modules.catalog_mode">
                        <div class="col-md-2">
                            <div class="input-group">
                                <span class="input-group-prepend"><button @click="qty > 1 ? qty-- : false" type="button" class="btn btn-light border">-</button></span>
                                <input type="text"  @focus="$event.target.select()" class="form-control text-center" v-model.number="qty">
                                <span class="input-group-prepend"><button @click="qty++" type="button" class="btn btn-light border">+</button></span>
                            </div>
                        </div>
                        <div class="col-md">
                            <button class="btn btn-primary" @click="addToCart" :disabled="!canOrder">
                                <i class="fas fa-shopping-bag"></i>
                                {{ t.product.add_to_cart }}
                            </button>
                            <a v-if="config.modules.buy_now && canOrder" class="btn btn-secondary" :href="selectedProduct.buyNow">{{ t.product.buy_now }}</a>
                        </div>
                    </div>
                    <div class="small" v-if="config.modules.stock && selectedProduct.stock <= 0">
                        <i class="fa-solid fa-triangle-exclamation"></i> {{ settings.order_out_of_stock ? t.product.restocking : t.product.out_of_stock}}
                    </div>
                    <div class="small" v-else-if="config.modules.stock && !settings.order_out_of_stock && selectedProduct.stock && selectedProduct.stock <= settings.low_stock">
                        <i class="fa-solid fa-triangle-exclamation"></i> {{ this.__('product', 'low_stock', {'stock': selectedProduct.stock})}}
                    </div>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs fw-bold">
            <li class="nav-item">
                <a class="nav-link active" id="description-tab" data-bs-toggle="tab" href="#description" role="tab"
                    aria-controls="description" aria-selected="true">{{ t.product.description }}</a>
            </li>
            <li v-if="selectedProduct.attributeValues.length" class="nav-item">
                <a class="nav-link" id="attribute-tab" data-bs-toggle="tab" href="#attribute" role="tab"
                    aria-controls="attribute" aria-selected="false">{{ t.product.attributes }}</a>
            </li>
            <li v-if="selectedProduct.video" class="nav-item">
                <a class="nav-link" id="video-tab" data-bs-toggle="tab" href="#video" role="tab"
                    aria-controls="video" aria-selected="false">{{ t.product.video }}</a>
            </li>
        </ul>
        <div class="tab-content p-3 border border-top-0 mb-5">
            <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab" v-html="selectedProduct.long_description"></div>
            <div v-if="selectedProduct.attributeValues.length" class="tab-pane fade" id="attribute" role="tabpanel" aria-labelledby="attribute-tab">
                    <div v-for="(attribute, index) in selectedProduct.attributeValues" :key="index" class="row" :class="{'bg-light': index%2}">
                        <div class="col fw-bold py-2">{{ attribute.name }}</div>
                        <div class="col py-2">
                            <span v-if="attribute.type == 'numeric'">{{attribute.numeric_value}}{{attribute.unitName}}</span>
                            <span v-else-if="attributeValue.type == 'boolean'">{{attributeValue.boolean_value ? t.global.yes : t.global.no}}</span>
                            <span v-else>
                                <span v-for="value in attribute.values" :key="value.id">{{value.name}}{{attribute.unitName}}</span>
                            </span>
                        </div>
                    </div>
            </div>
            <div v-if="selectedProduct.video" class="tab-pane fade" id="video" role="tabpanel" aria-labelledby="video-tab">
                <iframe width="100%" height="500px"
                    :src="'https://www.youtube.com/embed/'+selectedProduct.video"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </section>
</template>

<script>
import store from "../CartStore";
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);
export default {
    store: store,
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            product: product,
            variations: variations,
            selectedProduct: selectedProduct ? selectedProduct : product,
            qty: 1,
        };
    },
    computed: {
        canOrder() {
            if (config.modules.stock && !settings.order_out_of_stock && this.selectedProduct.stock <= 0) {
                return false
            }
            return true
        },
    },
    methods: {
        ...Vuex.mapActions(['addProduct', 'updateProduct']),
        addToCart() {
            var productToAddToCart = this.product
            if (this.variations && this.variations.length) {
                productToAddToCart = this.selectedProduct;
            }
            productToAddToCart.qty = this.qty
            this.addProduct(productToAddToCart);
        },
        changeUrl() {
            history.replaceState(
                {},
                null,
                this.url('product/'+this.selectedProduct.slug)
            )
        }
    },
};
</script>
